import { render, staticRenderFns } from "./CheckeredBackground.vue?vue&type=template&id=6704b0b9&scoped=true&"
import script from "./CheckeredBackground.vue?vue&type=script&lang=js&"
export * from "./CheckeredBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6704b0b9",
  null
  
)

export default component.exports